module.exports = __webpack_public_path__ + "img/jardin4.78fd3184.jpg";